import { IconProps } from './IconProps';

export const NewCheckmark = (props: IconProps) => {
  return (
    <svg
      style={props.style}
      className={props.className}
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.13544 23.3964C8.46341 23.3139 7.92776 22.954 7.52851 22.3166L1.98844 13.4759C1.83045 13.2348 1.72235 13.0041 1.66413 12.7838C1.61431 12.5645 1.60333 12.3414 1.63118 12.1146C1.69306 11.6106 1.91213 11.2154 2.28837 10.929C2.66462 10.6427 3.10895 10.5309 3.62138 10.5939C4.20101 10.665 4.65781 10.9727 4.99178 11.5168L9.60953 19.1186L22.3586 3.51895C22.6183 3.20975 22.874 3.00239 23.1257 2.89686C23.3784 2.78293 23.6812 2.74763 24.034 2.79095C24.5465 2.85387 24.9469 3.06505 25.2353 3.42449C25.5237 3.78394 25.6375 4.21147 25.5767 4.7071C25.5519 4.90871 25.4936 5.1062 25.4016 5.29956C25.3096 5.49292 25.1788 5.69003 25.0092 5.89091L10.9747 22.6886C10.4962 23.2523 9.88308 23.4882 9.13544 23.3964Z"
        fill={props.fill ?? 'black'}
      />
    </svg>
  );
};
